import React, {useEffect, useState} from 'react';
import DailyTasksDone from "../components/DailyTasks/DailyTasksDone";
import DailyTasksNotDone from "../components/DailyTasks/DailyTasksNotDone";
import * as TasksApi from "../api/tasks";
import {toast} from "react-toastify";
import toastOptions from "../data/ToastOptions";
import {useShallowPickSelector} from "../redux";
import * as TasksStore from '../redux/tasks'
import {useDispatch} from "react-redux";
import axios from 'axios';
import {baseUrl} from "../api/network";
import * as AppStore from "../redux/app";

const DailyTasks = () => {
    const {tgUser} = useShallowPickSelector('user', ['tgUser']);
    const {taskList, taskLoader} = useShallowPickSelector('tasks', ['taskList', 'taskLoader'])
    const [showCongrats, setShowCongrats] = useState(false);
    const [checkTaskLoader, setCheckTaskLoader] = useState(false);
    const dispatch = useDispatch()

    useEffect(() => {
        getTaskListFn()
    }, [])

    const getTaskListFn = () => {
        dispatch(TasksStore.actions.setTaskLoader(true))
        TasksApi.getTasksData()
            .then(response => {
                dispatch(TasksStore.actions.setTasksList(response.data.data))
                dispatch(TasksStore.actions.setTaskLoader(false))
            })
            .catch(() => {
                dispatch(TasksStore.actions.setTaskLoader(false))
                toast.error('Something went wrong! Please try again', {...toastOptions, toastId: 4})
            })
    }

    const checkTasksStatusFn = () => {
        const doneTasksIdPrev = localStorage.getItem('doneTaskIds') ?? "[]"
        if (JSON.parse(doneTasksIdPrev).length > 0) {
            // setCheckTaskLoader(true)
            const headers = {
                'Content-Type': 'application/json',
            }
            const lastData = {
                task_ids: JSON.parse(doneTasksIdPrev),
                user_tg_id: tgUser?.id,
            }
            axios.post(`${baseUrl}/tasks/check`, JSON.stringify(lastData), {headers})
                .then(() => {
                    getTaskListFn();
                    localStorage.removeItem('doneTaskIds');
                    dispatch(AppStore.getPointsDataFn())
                    setCheckTaskLoader(false)
                })
                .catch(() => {
                    setCheckTaskLoader(false)
                    toast.error('Something went wrong! Please try again', {...toastOptions, toastId: 2})
                })
        } else {
            toast.error('There are no completed tasks to check.', {...toastOptions, toastId: 3})
        }
    }

    useEffect(() => {
        if (taskList.length > 0) {
            const isItemsDone = taskList?.map(item => item?.is_done)
            if (isItemsDone.includes(false)) {
                setShowCongrats(false);
            } else {
                setShowCongrats(true);
            }
        }
    }, [taskList]);

    const setRefreshFn = () => {
        getTaskListFn()
    }

    return (
        <div className="container">
            <div className="tasks-taskContainer">
                <p className="text-white fs16 mt30 text-center">
                    Complete quests, rack up JPs, and watch your $JETs pile up.
                </p>
                <p className="text-white fs16 font-bold mt10 mb40">
                    Let’s get to work!
                </p>
                {taskLoader && (
                    <div className="center">
                        <div className="loader"></div>
                    </div>
                )}
                {!taskLoader && taskList && taskList?.length > 0 && !showCongrats && <div className="w100 center between">
                    <p className="text-white fs16 font-bold text-center">Tasks</p>
                    <button type="button" className="button mt5 mb5 mxUnset relative tasks-checkTasksExtraStyle" disabled={checkTaskLoader}
                            onClick={checkTasksStatusFn}>
                        <span className="text-white">Check Tasks</span>
                        {checkTaskLoader && <div className="center loaderInBtn">
                            <div className="loader"></div>
                        </div>}
                    </button>
                </div>}
                {!taskLoader && taskList?.length > 0 && taskList?.map((item, index) => {
                    if (!item.is_done) {
                        return <DailyTasksNotDone key={Math.random().toString()} item={item} index={index} type="daily" setRefresh={setRefreshFn}/>
                    } else {
                        return <DailyTasksDone key={Math.random().toString()} item={item} index={index} type="daily"/>
                    }
                })}
                {!taskLoader && taskList && taskList?.length === 0 && (
                    <div className="mt30 center column">
                        <p className="text-white fs14">Nothing To Show</p>
                        <svg
                            className="mt10"
                            width="25"
                            height="25"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="12" cy="12" r="10" stroke="#FFFFFF" strokeWidth="1" fill="none"/>
                            <circle cx="8" cy="9" r="1" fill="#FFFFFF"/>
                            <circle cx="16" cy="9" r="1" fill="#FFFFFF"/>
                            <path
                                d="M8 16 Q12 12 16 16"
                                stroke="#FFFFFF"
                                strokeWidth="1"
                                fill="none"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>
                )}
            </div>
            {!taskLoader && taskList && taskList?.length > 0 && showCongrats && <div className="my40">
                <p className="text-white fs50 font-normal text-center">Congrats!</p>
            </div>}
            {/*{!taskLoader && taskList && taskList?.length > 0 && !showCongrats && <div className="my40">*/}
            {/*    <p className="text-white fs16 text-center">If Tasks Done, Then Click on Check Tasks</p>*/}
            {/*    <button type="button" className="button mt30 mb30 relative" disabled={checkTaskLoader} onClick={checkTasksStatusFn}>*/}
            {/*        <span className="text-white">Check Tasks</span>*/}
            {/*        {checkTaskLoader && <div className="center loaderInBtn">*/}
            {/*            <div className="loader"></div>*/}
            {/*        </div>}*/}
            {/*    </button>*/}
            {/*</div>}*/}
            <div className="h50"></div>
        </div>
    );
}

export default DailyTasks;
